'use client';

import { Typography } from '@mui/material';
import { Container, ControlsBtn } from './styled';
import { CopyIcon, HeartIcon, PrintIcon, ReportIcon, ShareModal, ProdGate } from '@/components';
import { useTranslations } from 'next-intl';
import { useWatchlistCard, usePrintHousing } from '@/hooks';
import { FC, useState } from 'react';
import { COLORS } from '@/constants';
import { IHousingObjectResponse } from '@/types';
import { ReportObjectModal } from '../ReportObjectModal';

type ControlsProps = {
  housingId: string;
  title: string;
  description?: string;
  media: string;
  slugLink: string;
  isProject?: boolean;
  data: IHousingObjectResponse;
};

export const Controls: FC<ControlsProps> = ({
  media,
  title,
  description,
  slugLink,
  isProject,
  data,
}) => {
  const t = useTranslations();

  const { inWatchlist, toggleWatch } = useWatchlistCard(data, isProject);
  const { handlePrint } = usePrintHousing();

  const [isReportModalOpen, setIsReportModalOpen] = useState(false);

  const openReportHandler = () => setIsReportModalOpen(true);
  return (
    <Container>
      <ProdGate>
        <ControlsBtn onClick={handlePrint}>
          <PrintIcon stroke={COLORS['secondary/500']} />
          <Typography fontSize={12} fontWeight={700} lineHeight={1.25}>
            {t('housingCardDetails.printProperty')}
          </Typography>
        </ControlsBtn>
      </ProdGate>
      <ShareModal
        id={data.id}
        title={title}
        description={description}
        media={media}
        slugLink={slugLink}
        trigger={
          <ControlsBtn>
            <CopyIcon stroke={COLORS['secondary/500']} />
            <Typography fontSize={12} fontWeight={700} lineHeight={1.25}>
              {t('housingCardDetails.shareProperty')}
            </Typography>
          </ControlsBtn>
        }
      />
      <ControlsBtn onClick={toggleWatch}>
        <HeartIcon isActive={inWatchlist} stroke={COLORS['secondary/500']} />
        <Typography fontSize={12} fontWeight={700} lineHeight={1.25}>
          {t('housingCardDetails.saveProperty')}
        </Typography>
      </ControlsBtn>
      <ControlsBtn onClick={openReportHandler}>
        <ReportIcon />
        <Typography fontSize={12} fontWeight={700} lineHeight={1.25}>
          {t('housingCardDetails.reportProperty')}
        </Typography>
      </ControlsBtn>

      <ReportObjectModal isOpen={isReportModalOpen} setIsOpen={setIsReportModalOpen} />
    </Container>
  );
};
